'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EntertainingMotivationProgram = function (_Component) {
  (0, _inherits3.default)(EntertainingMotivationProgram, _Component);

  function EntertainingMotivationProgram() {
    (0, _classCallCheck3.default)(this, EntertainingMotivationProgram);
    return (0, _possibleConstructorReturn3.default)(this, (EntertainingMotivationProgram.__proto__ || (0, _getPrototypeOf2.default)(EntertainingMotivationProgram)).apply(this, arguments));
  }

  (0, _createClass3.default)(EntertainingMotivationProgram, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_reactHelmet2.default, { title: 'Zabavn\xFD motiva\u010Dn\xED program' }),
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'h1',
              null,
              'Z\xE1bavn\xFD motiva\u010Dn\xED program'
            ),
            _react2.default.createElement(
              'p',
              null,
              'D\u011Bti je pot\u0159eba st\xE1le n\u011B\u010D\xEDm motivovat, aby jejich snaha nepolevovala. Na na\u0161e nejmen\u0161\xED \u010Dek\xE1 speci\xE1ln\xED album na samolepky (Nud\xEDky), kter\xE9 budou dost\xE1vat za spln\u011Bn\xED r\u016Fzn\xFDch \xFAkol\u016F. Z\xEDskat je mohou na tr\xE9ninku, ale i doma. Za zkompletov\xE1n\xED alba je \u010Dek\xE1 odm\u011Bna.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Pro star\u0161\xED d\u011Bti jsme p\u0159ipravili vlastn\xED on-line aplikaci, kde budou dost\xE1vat Nud\xEDky za pr\xE1ci v\xA0kolektivu a pln\u011Bn\xED \xFAkol\u016F. \u010C\xEDm v\xEDc Nud\xEDk\u016F nasb\xEDraj\xED, t\xEDm bude r\u016Fst jejich avatar. V\u0161e budou m\xEDt p\u0159ehledn\xE9 a p\u0159i ruce ve sv\xE9m telefonu, tabletu nebo po\u010D\xEDta\u010Di.'
            )
          )
        )
      );
    }
  }]);
  return EntertainingMotivationProgram;
}(_react.Component);

exports.default = EntertainingMotivationProgram;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EntertainingMotivationProgram/EntertainingMotivationProgram.js
// module id = 1107
// module chunks = 0